"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.garmentUnitPrice = exports.garmentBreaks = void 0;
function garmentBreaks(product) {
    const tiers = (Array.isArray(product.quantityPricing) ? product.quantityPricing : [])
        .filter((t) => t && typeof t.minQty === 'number' && typeof t.price === 'number')
        .sort((a, b) => a.minQty - b.minQty);
    // The product's own price is the "from 1" row, unless a break already starts at 1.
    return product.price > 0 && !tiers.some((t) => t.minQty <= 1) ? [{ minQty: 1, price: product.price }, ...tiers] : tiers;
}
exports.garmentBreaks = garmentBreaks;
function garmentUnitPrice(product, quantity) {
    const breaks = garmentBreaks(product);
    let unit = null;
    for (const b of breaks)
        if (quantity >= b.minQty)
            unit = b.price;
    if (unit === null && breaks.length > 0)
        unit = breaks[0].price;
    return unit !== null && unit > 0 ? unit : null;
}
exports.garmentUnitPrice = garmentUnitPrice;
